import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {makeStyles} from '@material-ui/core';

import payoutActions from '../../actions/payout.actions';
import {PayoutReportList} from './components';
import {PayoutViewProps} from './PayoutView';
import {PayoutReportState} from '../../reducers/payout';
import {LoadMore} from './components';

export interface PayoutProps extends PayoutViewProps {
    reportState: PayoutReportState;
}

const useStyles = makeStyles(theme => ({
    root: {
        minHeight: `${theme.spacing(8)}rem`,
        maxHeight: `${theme.spacing(8)}rem`,
        overflow: 'auto'
    }
}));

const Payout: React.FC<PayoutProps> = props => {
    const dispatch = useDispatch();
    const styles = useStyles();

    const loadPayoutList = useCallback((paging?) => {
        dispatch(payoutActions.getPayoutReportList(paging));
    }, []);

    const loadPayoutDetail = useCallback(data => {
        dispatch(payoutActions.getPayoutReportDetail(data));
    }, []);

    return (
        <div className={styles.root}>
            <PayoutReportList
                reportState={props.reportState}
                getPayoutReportDetail={loadPayoutDetail}
            />
            <LoadMore
                isLimited={props.reportState.isLimited}
                isLoading={props.reportState.loadingList}
                loadPayoutList={loadPayoutList}
            />
        </div>
    );
};

export default Payout;
